import {
  Bell,
  ClipboardList,
  CreditCard,
  Plug,
  Settings,
  Users,
  Zap,
} from 'lucide-react';

/** Canonical settings links migrated from sidebar Settings & Admin + memo §8 matrix. */
export const SETTINGS_SECTIONS = [
  {
    title: 'Account',
    items: [
      {
        icon: Bell,
        label: 'Notification Preferences',
        path: '/settings/notifications',
      },
    ],
  },
  {
    title: 'Organization',
    visibleFor: ['gcAdmin', 'scAdmin', 'admin'],
    items: [
      { icon: Users, label: 'User Management', path: '/admin/users' },
      {
        icon: ClipboardList,
        label: 'Activity Log',
        path: '/admin/activity',
        visibleFor: ['gcAdmin', 'admin'],
      },
      { icon: Settings, label: 'Settings', path: '/settings' },
    ],
  },
  {
    title: 'Integrations',
    visibleFor: ['gcAdmin', 'admin'],
    items: [
      {
        icon: Plug,
        label: 'Procore Integration',
        path: '/settings/integrations/procore',
      },
      { icon: Zap, label: 'Automation', path: '/settings/automation' },
    ],
  },
  {
    title: 'Billing',
    visibleFor: ['gcAdmin', 'admin'],
    items: [{ icon: CreditCard, label: 'Billing', path: '/billing' }],
  },
];

export function isVisibleForRole(visibleFor, role) {
  if (!visibleFor || visibleFor.length === 0) {
    return true;
  }
  return visibleFor.includes(role);
}

export function filterSettingsSections(role, sections = SETTINGS_SECTIONS) {
  const normalizedRole = role || 'worker';

  return sections
    .filter((section) => isVisibleForRole(section.visibleFor, normalizedRole))
    .map((section) => ({
      ...section,
      items: section.items.filter((item) =>
        isVisibleForRole(item.visibleFor, normalizedRole)
      ),
    }))
    .filter((section) => section.items.length > 0);
}
